import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { ButtonText, ICONS, GUEST_PERMISSIONS } from "@loanbossinc/component-library";
import { ActiveHedgeDataTable } from "./activeHedgeDataTable";
import { WatchHedgeDataTable } from "./watchHedgeDataTable";
import { Collapse } from "@material-ui/core";
import { activeLoanGetActiveHedges, activeLoanGetWatchHedges } from "../activeLoan.store";
import { StyledModuleFooter, StyledFooterText } from "component-lib/ModuleFooter";

const SELECTION_LABELS = {
    ACTIVE_HEDGE: "active hedge"
    , WATCH_HEDGE: "monitored hedge"
    , SHOW_LESS: "Show Less"
    , NO_HEDGES: "No hedges"
}

class ActiveLoanHedge extends Component {
    state = {
        activeHedges: [],
        watchHedges: [],
        isExpanded: false,
        iconName: ICONS.UNFOLD_MORE,
    };

    componentDidMount() {
        const { dealId } = this.props
        this.props.activeLoanGetActiveHedges({ dealId });
        this.props.activeLoanGetWatchHedges({ dealId });
    }

    componentDidUpdate(prevProps, prevState) {
        const { activeHedges, watchHedges } = this.props;
        if (activeHedges !== prevProps.activeHedges) { this.setState({ activeHedges }); }
        if (watchHedges !== prevProps.watchHedges) { this.setState({ watchHedges }); }
    }

    toggleIsExpanded = () => {
        this.renderTable();
        this.setState({
            isExpanded: !this.state.isExpanded,
            iconName: !this.state.isExpanded ? ICONS.UNFOLD_LESS : ICONS.UNFOLD_MORE
        });
    }

    shouldPluralize = (count, word, suffix = 's') => `${count} ${word}${count > 1 ? suffix : ''}`;
    
    renderActiveHedgeTable = () => {
        const { history } = this.props;
        const { activeHedges, isExpanded } = this.state;
        return (
            <Collapse in={isExpanded}>
                <ActiveHedgeDataTable activeHedges={activeHedges} history={history} />
            </Collapse>
        )
    }

    renderWatchHedgeTable = () => {
        const { history } = this.props;
        const { watchHedges, isExpanded } = this.state;
        return (
            <Collapse in={isExpanded}>
                <WatchHedgeDataTable watchHedges={watchHedges} history={history} />
            </Collapse>
        )
    }

    renderTable = () => {
        const { activeHedges, watchHedges, iconName } = this.state;
        return (
            <div>
                {activeHedges.length > 0 && this.renderActiveHedgeTable()}
                {watchHedges.length > 0 && this.renderWatchHedgeTable()}
            </div>
        )
    }

    findButtonLabel = () => {
        const { activeHedges, watchHedges } = this.state;

        if (activeHedges.length && watchHedges.length)
            return (`${this.shouldPluralize(activeHedges.length, SELECTION_LABELS.ACTIVE_HEDGE)} 
                        and ${this.shouldPluralize(watchHedges.length, SELECTION_LABELS.WATCH_HEDGE)} `)

        if (activeHedges.length)
            return (`${this.shouldPluralize(activeHedges.length, SELECTION_LABELS.ACTIVE_HEDGE)}`)

        if (watchHedges.length)
            return (`${this.shouldPluralize(watchHedges.length, SELECTION_LABELS.WATCH_HEDGE)}`)

    }

    renderFooterButton = () => {

        const { authentication, guestPermission } = this.props;
        const { isExpanded, iconName} = this.state;
        
        if (isExpanded)
            return (
                <div>
                    {authentication.isGuest && guestPermission && guestPermission.portfolioPermissionId === GUEST_PERMISSIONS.VIEW
                        ? (
                            <StyledModuleFooter>
                                <ButtonText label={SELECTION_LABELS.SHOW_LESS} onClick={this.toggleIsExpanded} iconName={iconName} />
                            </StyledModuleFooter>
                        ) : (
                            <StyledModuleFooter>
                                <ButtonText
                                    label={SELECTION_LABELS.ADD_A_HEDGE}
                                    onClick={() => { this.createNewHedge() }} />
                                <ButtonText onClick={this.toggleIsExpanded} iconName={iconName} />
                            </StyledModuleFooter>
                        )
                    }
                </div>
            )

        if (!isExpanded)
            return (
                <div>
                    <StyledModuleFooter>
                        <ButtonText
                            label={this.findButtonLabel()}
                            onClick={this.toggleIsExpanded}
                            iconName={iconName} />
                    </StyledModuleFooter>
                </div>
            )

    }

    render() {
        const { authentication } = this.props;
        const { activeHedges, watchHedges } = this.state;
        if (!activeHedges.length && !watchHedges.length && !authentication.isGuest) {
            return (
                <StyledModuleFooter>
                    <StyledFooterText>{SELECTION_LABELS.NO_HEDGES}</StyledFooterText>
                    <ButtonText alignRight label={SELECTION_LABELS.ADD_A_HEDGE} onClick={this.createNewHedge} />
                </StyledModuleFooter>
            )
        }
        return (
            <div >
                {this.renderTable()}
                {this.renderFooterButton()}
            </div>
        )
    }
}

const mapStateToProps = ({ authentication, activeLoanModule }) => ({
    ...activeLoanModule
    , ...activeLoanModule.activeLoanModuleReducer
    , authentication
});

export default compose(
    withRouter,
    connect(mapStateToProps, {
        activeLoanGetActiveHedges
        , activeLoanGetWatchHedges
    })
)(ActiveLoanHedge);
